<div mat-dialog-content class="form-container">
  <form [formGroup]="datosInstalacion" class="form__datosInstalacion">
    <p class="warningInstalacion">Antes de dar de Alta una Instalación, por favor asegúrese de haber creado previamente sus Zonas.</p>
    <h1>Alta Instalación</h1>
    <div>
      <h2>Datos Instalación</h2>
      <div class="datos__datos">
        <mat-form-field appearance="outline">
          <mat-label>Denominación de la Instalación</mat-label>
          <input
            matInput
            placeholder="Denominación"
            formControlName="nombre"
            required
          />
          <mat-error>Campo Obligatorio</mat-error>
        </mat-form-field>
      </div>
      <h2>Dirección de la Instalación</h2>

      <div class="datos__direccion">
        <mat-form-field appearance="outline" class="via">
          <mat-label>Tipo de vía</mat-label>
          <mat-select placeholder="vía" formControlName="via">
            <mat-option value="Calle">Calle</mat-option>
            <mat-option value="Avenida">Avenida</mat-option>
            <mat-option value="Paseo">Paseo</mat-option>
            <mat-option value="Plaza">Plaza</mat-option>
            <mat-option value="Otro">Otro</mat-option>
          </mat-select>
          <mat-error>Campo Obligatorio</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="nombre">
          <mat-label>Nombre de la vía</mat-label>
          <input
            matInput
            placeholder="Nombre de la vía"
            formControlName="nombreVia"
            required
          />
          <mat-error>Campo Obligatorio</mat-error>
        </mat-form-field>

        <div class="datos">
          <mat-form-field appearance="outline">
            <mat-label>Nº</mat-label>
            <input matInput placeholder="Nº" formControlName="numero" required />
            <mat-error>Campo Obligatorio</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Pta.</mat-label>
            <input matInput placeholder="Pta" formControlName="pta" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Letra</mat-label>
            <input matInput placeholder="letra" formControlName="letra" />
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Provincia</mat-label>
          <mat-select formControlName="provincia">
            <mat-option *ngFor="let provincia of provincias" [value]="provincia" #matOption (click)="selectProvincia(matOption)">
              {{provincia.NOMBRE}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline"  *ngIf="autonomia">
          <mat-label>Comunidad Autónoma</mat-label>
          <input
            matInput
            placeholder="Comunidad Autónoma"
            formControlName="ccaa"
            required
            [(ngModel)]="autonomia"
          />
          <mat-error>Campo Obligatorio</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Código Postal</mat-label>
          <input matInput placeholder="Código Postal" formControlName="cp" required/>
          <mat-error>Campo Obligatorio</mat-error>
        </mat-form-field>
      </div>

      <h2>Zonas</h2>
      <div class="datos__datos">
        <mat-form-field appearance="outline">

          <mat-label>Zonas</mat-label>
          <mat-select formControlName="zonas" multiple>
            
            <mat-checkbox (change)="selectAllZonas($event.checked)" ><strong>Seleccionar Todas</strong></mat-checkbox>
            <mat-option *ngFor="let zona of zonas" [value]="zona.id" #matOption (click)="selectZona(matOption)">{{zona.nombre}}</mat-option>

 
          </mat-select>
        </mat-form-field>
      <ng-container *ngIf="grupos.length > 0">
      <h2>Grupos</h2> 
      <mat-form-field appearance="outline">

        <mat-label>Grupos</mat-label>
        <mat-select formControlName="grupos">
          <mat-option *ngFor="let grupo of grupos" [value]="grupo.id" #matOption (click)="selectGrupo(matOption)">{{grupo.nombre}}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
      <ng-container *ngIf="campos.length > 0">
      
      <h2>Campos({{nombreGrupo}})</h2> 
      <mat-form-field appearance="outline">

        <mat-label>Campos</mat-label>
        <mat-select formControlName="grupos" multiple>
        
          <mat-option *ngFor="let campo of campos" [value]="campo" #matOption (click)="selectCampo(matOption)">{{campo.nombre}}</mat-option>
         

        </mat-select>
      </mat-form-field>
    </ng-container>
    <div *ngIf="allCampos.length > 0">
      <h3>Campos seleccionados</h3>
      <ng-container *ngFor="let campo of allCampos">
        <p>• {{campo.nombre}}({{campo.agrupacion.nombre}})</p>
      </ng-container>
      
    </div>
      </div>

      <div class="radio__contratista">
        <h2>Contratista</h2>
        <div class="radioButton">
          <div class="contratistas" *ngFor="let contratista of contratistas">
            <div *ngIf= "contratista.nombreComercial !== null">
              <input
                type="radio"
                value="{{ contratista.id }}"
                formControlName="contratista"
                id="contratistas"
                multiple
              />
              <label for="contratista">{{ contratista.nombreComercial }}</label>
            </div>
            <div class="contratistas" *ngIf= "contratista.nombreComercial === null">
              <input
                type="radio"
                value="{{ contratista.id }}"
                formControlName="contratista"
                id="contratistas"
                multiple
              />
              <label for="contratista">{{ contratista.contactoResponsable.mail }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boton__siguiente">
      <button
        type="submit"
        (click)="save($event)"
        [mat-dialog-close]
        [disabled]="datosInstalacion.invalid"
      >
        Hecho
      </button>
    </div>
  </form>
</div>
